import { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";
import { useItemsStore } from '../../../contexts/zustand/onboarding';
import { APIOnboarding } from "../../../services/api";
import { useAuth } from "../../../hooks/useAuth";
import DvrIcon from '@mui/icons-material/Dvr';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import { LoadingPage } from "../../../components/LoadingPage"

import { toast } from "react-toastify";
import JSON5 from 'json5';

import * as TimelineLib from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { Box } from '@mui/material';

const VerticalTimeline = TimelineLib.VerticalTimeline as unknown as React.FC<any>;
const VerticalTimelineElement = TimelineLib.VerticalTimelineElement as unknown as React.FC<any>;


type LogItem = {
    title: string;
    user: string;
    date: string;
    description: string;
    type_user: string;
    created_at: string;
};

type DataProcess = {
    label: string;
    value: string;
}

const formatDateAndHours = (dateToConvert: string) => {
    const dateTime = dateToConvert.split('T');

    const date = dateTime[0];
    const time = dateTime[1];

    const [year, month, day] = date.split('-');
    const [hours, minutes, seconds] = time.split(':');

    let dateObject = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hours), parseInt(minutes), parseInt(seconds));

    const formattedDate = format(dateObject, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
    
    dateObject.setHours(dateObject.getHours() - 3);

    const formattedTime = dateObject.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
    });

    return [formattedDate, formattedTime];
};


export default function ViewLogsProcess() {

    const { id_signatory } = useParams();

    const { user } = useAuth();

    const { checkPermissionOnboarding } = useItemsStore()

    const [logsProcess, setLogsProcess] = useState<LogItem[]>([])

    const [loadingPage, setLoadingPage] = useState<boolean>(true)

    const [numberProcess, setNumberProcess] = useState<DataProcess[]>([])

    useEffect(() => {

        const fetchData = async () => {

            try {
                const response = await APIOnboarding.get(
                    `onboarding/signatory/list/?id=${id_signatory}&token=${checkPermissionOnboarding.token}`
                );

                const reorder = response.data.content.results[0].response_logs_process.sort(
                    (a: LogItem, b: LogItem) =>
                        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
                );

                setNumberProcess(response.data.content.results[0].data.filter((item: DataProcess) => item.label === "numero_processo"))

                setLogsProcess(reorder)
            } catch (erro) {
                toast.error('Ops. houve um error, tente novamente mais tarde!!!!', { autoClose: 2000 })
            }

            setLoadingPage(false)
        }

        fetchData()
    }, [id_signatory, user?.corporate_id, checkPermissionOnboarding])

    const TimeLinelogs = () => {

        return (
            <VerticalTimeline>
                {logsProcess.map((item, index: number) => {
                    const [sendDateAt, sendHoursAt] = formatDateAndHours(item.created_at);
                    const user = item.user;

                    function fixJson5String(input: any) {
                        return input.replace(
                            /<strong>{(.*?)}<\/strong>/g,
                            (_: any, inner: any) => {
                                const cleaned = inner.replace(/"/g, '\\"').replace(/'/g, '\\"');
                                return `<strong>{\\"${cleaned}\\"}</strong>`;
                            }
                        );
                    }

                    const fixed = fixJson5String(item.description);
                    const parsed = JSON5.parse(fixed);

                    const title = parsed.title;
                    const message = parsed.message

                    const isSystem = item.type_user === '1';

                    return (
                        <VerticalTimelineElement
                            key={index}
                            position={isSystem ? 'left' : 'right'}
                            contentStyle={{
                                background: isSystem ? "#D2D3D5" : "#9756A1",
                                color: isSystem ? '#000' : "#FFF",
                                borderRadius: '10px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                            }}
                            contentArrowStyle={{
                                borderRight: isSystem ? '7px solid #fff' : '',
                                borderLeft: !isSystem ? '7px solid #fff' : '',
                            }}
                            iconStyle={{
                                background: isSystem ? '#D2D3D5' : '#9756A1',
                                color: '#fff',
                            }}
                            icon={isSystem ? <DvrIcon /> : <AccountCircleIcon />}
                        >
                            {title && <p><span dangerouslySetInnerHTML={{ __html: title }} /></p>}
                            <p><strong>Data:</strong> {sendDateAt} às {sendHoursAt}</p>
                            <p><strong>Usuário:</strong> {isSystem ? user : 'Cliente'}</p>
                            <p>
                                <strong>Descrição:</strong>{' '}
                                <span
                                    style={{
                                        wordBreak: 'break-word',
                                        whiteSpace: 'pre-wrap',
                                        overflowWrap: 'break-word',
                                    }}
                                    dangerouslySetInnerHTML={{ __html: message }}
                                />
                            </p>

                        </VerticalTimelineElement>
                    );
                })}
            </VerticalTimeline>
        );
    };

    return (
        loadingPage ? (
            <LoadingPage />
        ) : (
            <div style={{ backgroundColor: '#f4f4f4', padding: '20px' }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '35px',
                        textDecoration: 'Bold',
                        marginBottom: '5px'
                    }}>TimeLine do Processo: {numberProcess[0].value}</Box>
                <TimeLinelogs />
            </div>
        )
    );
}